(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["identity-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SPEED = 52;

  function setup(bar) {
    if (!bar || bar.dataset.marqueeReady === 'true') return;
    var grid = bar.querySelector('.identity-grid');
    var track = bar.querySelector('.identity-track');
    if (!grid || !track) return;

    bar.dataset.marqueeReady = 'true';
    grid.style.animation = 'none';

    var paused = false;
    var offset = 0;
    var last = performance.now();

    bar.addEventListener('mouseenter', function () { paused = true; });
    bar.addEventListener('mouseleave', function () {
      paused = false;
      last = performance.now();
    });

    function tick(now) {
      if (!paused) {
        var dt = Math.min(0.05, (now - last) / 1000);
        offset += SPEED * dt;
        var width = track.offsetWidth;
        if (width > 0 && offset >= width) offset -= width;
        grid.style.transform = 'translate3d(' + (-offset) + 'px, 0, 0)';
      }
      last = now;
      requestAnimationFrame(tick);
    }

    requestAnimationFrame(tick);
  }

  function init() {
    document.querySelectorAll('.identity-bar').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var bar = event.target && event.target.querySelector
      ? event.target.querySelector('.identity-bar')
      : null;
    if (bar) {
      delete bar.dataset.marqueeReady;
      setup(bar);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
